import { z } from 'zod'

const QUOTA_NAME_MAX_LENGTH = 1000

export const quotaMetadataSchema = z.object({
  goal: z.string({ required_error: 'Goal must be a whole number of at least 1' }).refine((value) => {
    const goal = Number(value)

    return Number.isInteger(goal) && goal >= 1
  }, 'Goal must be a whole number of at least 1'),
  name: z
    .string({ required_error: 'Quota name is required' })
    .trim()
    .min(1, 'Quota name is required')
    .max(QUOTA_NAME_MAX_LENGTH, `Must be at most ${QUOTA_NAME_MAX_LENGTH} characters`),
})

export type QuotaMetadataFormValues = z.infer<typeof quotaMetadataSchema>
